import { CANVAS_HEIGHT, CANVAS_WIDTH, SCHEMA_VERSION } from './constants';
import type { Layer, Page, Work } from './document';

export function genId(prefix = ''): string {
  const s = Math.random().toString(36).slice(2, 8) + Date.now().toString(36).slice(-4);
  return prefix ? `${prefix}_${s}` : s;
}

export function createPage(partial: Partial<Page> = {}): Page {
  return {
    id: genId('p'),
    name: '',
    mode: 'fixed',
    height: CANVAS_HEIGHT,
    background: { type: 'color', color: '#ffffff' },
    transition: 'slide-up',
    layers: [],
    ...partial,
  };
}

export function createLayer(type: string, partial: Partial<Layer> = {}): Layer {
  return {
    id: genId('l'),
    type,
    materialVersion: 1,
    name: '',
    rect: { x: 0, y: 0, w: 100, h: 100, rotate: 0 },
    anchor: 'top',
    style: { opacity: 1, zIndex: 0 },
    props: {},
    animations: [],
    events: [],
    locked: false,
    hidden: false,
    ...partial,
  };
}

export function createWork(partial: Partial<Work> = {}): Work {
  return {
    schemaVersion: SCHEMA_VERSION,
    id: genId('w'),
    title: '未命名作品',
    canvas: { width: CANVAS_WIDTH, height: CANVAS_HEIGHT },
    globals: { fonts: [], loading: 'default', share: { title: '', desc: '', image: '' } },
    pages: [createPage({ name: '第 1 页' })],
    popups: [],
    fixeds: [],
    ...partial,
  };
}
